// DashboardLayout.js
// Wraps pages with Sidebar. Main content margin transitions smoothly when sidebar expands.

import React from 'react';
import Sidebar from './Sidebar';
import { SidebarProvider, useSidebar } from '../../contexts/SidebarContext';

function LayoutInner({ children }) {
  const { isExpanded } = useSidebar();
  return (
    <div className="min-h-screen bg-slate-50 flex">
      {/* Sidebar — fixed, manages own hover state */}
      <Sidebar />

      {/* Main content — margin transitions with sidebar expand */}
      <div
        className="flex-1 min-h-screen bg-slate-50 transition-all duration-200 ease-in-out"
        style={{ marginLeft: isExpanded ? 256 : 64 }}
      >
        {children}
      </div>
    </div>
  );
}

export default function DashboardLayout({ children }) {
  return (
    <SidebarProvider>
      <LayoutInner>{children}</LayoutInner>
    </SidebarProvider>
  );
}
